module.exports = __webpack_public_path__ + "img/about-bio-2@2x.2ab3f5ad.jpg";